export const related = [
  '/trophies',
  '/quests/power-lines',
  '/quests/into-the-sinkhole',
];
export const quickAnswer =
  'Right → Left → Right → Top → Left → Bottom → Right → Top → Right.';
export const sourceIds = ['powerpyx-party'];

## All 9 Karaoke Choice Directions

1. Right
2. Left
3. Right
4. Top
5. Left
6. Bottom
7. Right
8. Top
9. Right

## How the Trophy Attempt Works

In The Party Won’t Stop, use the karaoke machine and match each choice by direction. The trophy attempt requires saving everyone. No lyrics are reproduced here.

## What If You Pick the Wrong Choice?

An incorrect choice can void the attempt. Stop before progressing further and inspect available saves.

## Can You Retry?

The published walkthrough recommends loading a save before the mistake. Confirm that your save actually predates it; a completed or overwritten attempt is not guaranteed to be recoverable. Keep an earlier save available before starting.
